"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.clamp = exports.isNumeric = exports.parseNumber = exports.getUniqueObjectItems = exports.isSameObject = exports.objectWith = exports.removeFromArray = void 0;
const removeFromArray = (arr, value) => {
    if (!Array.isArray(arr) || !arr.includes(value))
        return [];
    return arr.filter((elem) => elem !== value);
};
exports.removeFromArray = removeFromArray;
const objectWith = (obj, keys) => {
    const r = {};
    keys.forEach((key) => {
        if (!(key in obj))
            return;
        r[key] = obj[key];
    });
    return r;
};
exports.objectWith = objectWith;
const isSameObject = (obj1, obj2) => {
    const compareKeys = ["id", "IsDiscounted"];
    obj1 = (0, exports.objectWith)(obj1, compareKeys);
    obj2 = (0, exports.objectWith)(obj2, compareKeys);
    const aKeys = Object.keys(obj1);
    const bKeys = Object.keys(obj2);
    if (aKeys.length !== bKeys.length)
        return false;
    const allKeys = [...new Set([...aKeys, ...bKeys])];
    return allKeys.every((key) => {
        return key in obj2 && key in obj1 && obj2[key] === obj1[key];
    });
};
exports.isSameObject = isSameObject;
const getUniqueObjectItems = (items) => {
    if (!Array.isArray(items))
        return [];
    items = JSON.parse(JSON.stringify(items));
    const uniqueItems = [];
    items.forEach((item) => {
        if (uniqueItems.find((i) => (0, exports.isSameObject)(i, item)))
            return;
        uniqueItems.push(item);
    });
    return uniqueItems;
};
exports.getUniqueObjectItems = getUniqueObjectItems;
const parseNumber = (str, decimalPoint = ".") => {
    if (!(0, exports.isNumeric)(str))
        return;
    if (str.includes(decimalPoint))
        return parseFloat(str);
    return parseInt(str);
};
exports.parseNumber = parseNumber;
const isNumeric = (value, decimalPoint = ".") => {
    if (typeof value === "number")
        return value !== Infinity;
    if (typeof value !== "string")
        return false;
    value = value.trim();
    if (!value.length || value === "Infinity")
        return false;
    return !isNaN(value) && !isNaN(parseFloat(value));
};
exports.isNumeric = isNumeric;
const clamp = (value, min, max) => {
    if (max && value > max)
        return max;
    if (value < min)
        return min;
    return value;
};
exports.clamp = clamp;
const sum = (...values) => {
    if (!values?.length)
        return 0;
    return values.reduce((total, v) => total + v);
};
exports.sum = sum;
